import { useScrollReveal } from '../../hooks/useScrollReveal';

const features = [
  {
    id: 1,
    category: 'Atelier',
    title: 'Espacio de Alta Costura en el Eixample',
    image: '/assets/anthony/feature-atelier-space.jpg',
  },
  {
    id: 2,
    category: 'Artesanía',
    title: 'Bordados a Mano con Hilo de Oro',
    image: '/assets/anthony/feature-artesania-thread.jpg',
  },
  {
    id: 3,
    category: 'Proceso',
    title: 'Cada Prenda, Una Historia Única',
    image: '/assets/anthony/feature-proceso-draping.jpg',
  },
];

export default function FeaturesGrid() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 40, duration: 900 });
  const { ref: ref2, isVisible: visible2, style: style2 } = useScrollReveal({ threshold: 0.1, distance: 40, duration: 900, delay: 150 });

  return (
    <section className="w-full bg-brand-gray-50 py-20 md:py-32">
      <div className="px-6 lg:px-[7%]">
        {/* Title Area */}
        <div ref={ref} className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 lg:gap-16" style={style}>
          <div className="lg:w-[45%]">
            <span className="font-sans text-brand-gray-300 text-[clamp(2rem,4vw,3.5rem)] font-bold leading-[1.1] block">
              Excelencia en
            </span>
            <span className="font-serif text-brand-black text-[clamp(2.5rem,5vw,4rem)] italic leading-[1.1] block">
              Cada Detalle
            </span>
          </div>

          <div ref={ref2} className="lg:w-[50%] grid grid-cols-1 sm:grid-cols-2 gap-6" style={style2}>
            <p className="font-sans text-brand-gray-500 text-[15px] leading-[1.9]">
              Desde la selección de materiales hasta el último puntada, cada paso de nuestro
              proceso está cuidadosamente diseñado para crear prendas que trascienden el tiempo.
            </p>
            <p className="font-sans text-brand-gray-500 text-[15px] leading-[1.9]">
              Nuestro atelier en Barcelona es un templo de la alta costura, donde la tradición
              artesanal se fusiona con la visión contemporánea de Anthony Sánchez.
            </p>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="group bg-white rounded-3xl overflow-hidden border border-transparent hover:border-brand-gray-100 transition-all duration-500 hover:-translate-y-1"
              style={isVisible ? {
                opacity: 1,
                transform: 'translateY(0px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${300 + index * 160}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${300 + index * 160}ms`,
              } : {
                opacity: 0,
                transform: 'translateY(36px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${300 + index * 160}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${300 + index * 160}ms`,
                willChange: 'opacity, transform',
              }}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute bottom-4 left-4 bg-brand-sage text-brand-black font-sans text-xs tracking-wider uppercase px-5 py-2 rounded-full transition-transform duration-500 group-hover:translate-y-0">
                  {feature.category}
                </span>
              </div>

              <div className="px-6 pt-5 pb-8">
                <h3 className="font-serif text-brand-black text-xl md:text-2xl font-medium leading-[1.4] group-hover:text-brand-gray-500 transition-colors duration-300">
                  {feature.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}